export default "__VITE_ASSET__BP$6POaH__"